import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../features/api/apiSlice";
import {
  imgUploadApiSlice
} from "../features/api/imageUploadApi";
import authSliceReducer from "../features/auth/authSlice";
import filterSliceReducer from "../features/filter/filterSlice";
export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [imgUploadApiSlice.reducerPath]: imgUploadApiSlice.reducer,
    auth: authSliceReducer,
    filter: filterSliceReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddlewares) =>
    getDefaultMiddlewares().concat(apiSlice.middleware),
});
